<div [hidden]="!PartialViewReady">
    <h2 class="mat-title">Student Search</h2>
    <div [hidden]="!ShowSearch">
        <form [formGroup]="SearchForm" novalidate>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start stretch" fxLayoutGap.lt-md="10px">
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start stretch" fxLayoutGap.lt-md="10px">
                    <mat-form-field>
                        <input matInput #firstinput type="search" id="firstname" formControlName="FirstName" placeholder="First Name" autofocus />
                    </mat-form-field>
                    <mat-form-field>
                        <input matInput #lastinput type="search" formControlName="LastName" placeholder="Last Name" />
                    </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start stretch" fxLayoutGap.lt-md="10px">
                    <mat-form-field>
                        <input matInput #studentidinput type="search" formControlName="StudentID" placeholder="Student ID" />
                    </mat-form-field>
                    <mat-form-field>
                        <mat-select formControlName="Grade" placeholder="Grade Level">
                            <mat-option *ngFor="let grade of AvailableSchoolGrades" [value]="grade">{{grade}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field *ngIf="User.CurrentRole === 'Developer' || User.CurrentRole === 'DistrictAdmin'">
                        <mat-select formControlName="SchoolNumber" placeholder="School">
                            <mat-option value="0000">Any</mat-option>
                            <mat-option *ngFor="let school of AvailableSchools" [value]="school.SchoolNumber">{{school.SchoolName}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div *ngIf="SearchForm.hasError('TooFewCharacters')"><em class="error">You must provide at least 5 characters combined between first name and last name search fields if you are not restricting by student ID, grade level, or school.</em></div>
            <div *ngIf="SearchForm.hasError('noneprovided')"><em>You must provide at least 1 search field in order to conduct a student search.</em></div>
            <div class="actionbar" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="15px">
                <button mat-raised-button color="primary" (click)="HandleSearch()" [disabled]="SearchForm.invalid">Search</button>
                <button mat-raised-button color="warn" (click)="ClearForm()">Reset</button>
            </div>
        </form>
    </div>
    <div *ngIf="SmallDisplay && SearchConducted" class="centered">
        <button type="button" color="primary" mat-raised-button (click)="ShowSearchForm()">Search Again</button>
    </div>
    <div [hidden]="!SearchConducted">
        <div *ngIf="HasAnyUpcoming">
            <mat-icon>info</mat-icon> denotes <em>tentative</em> student information for the upcoming school year. Student data is subject to change.
        </div>
        <mat-table class="bordered" #table [dataSource]="SearchData" matSort matSortActive="LastName" matSortDirection="asc">
            <ng-container matColumnDef="StudentID">
                <mat-header-cell *matHeaderCellDef class="centered" mat-sort-header>Student ID</mat-header-cell>
                <mat-cell *matCellDef="let student" class="centered">
                    <mat-icon *ngIf="student.UpcomingSchoolYear">info</mat-icon>
                    <span>{{student.StudentID}}</span>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="LastName">
                <mat-header-cell *matHeaderCellDef class="centered" mat-sort-header>Last Name</mat-header-cell>
                <mat-cell *matCellDef="let student" class="centered">{{student.LastName | titleCase}}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="FirstName">
                <mat-header-cell *matHeaderCellDef class="centered" mat-sort-header>First Name</mat-header-cell>
                <mat-cell *matCellDef="let student" class="centered">{{student.FirstName | titleCase}}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="MiddleName">
                <mat-header-cell *matHeaderCellDef class="centered" mat-sort-header>Middle Name</mat-header-cell>
                <mat-cell *matCellDef="let student" class="centered">{{student.MiddleName | titleCase}}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="School">
                <mat-header-cell *matHeaderCellDef class="centered" mat-sort-header>School</mat-header-cell>
                <mat-cell *matCellDef="let student" class="centered">{{student.SchoolName}}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="Grade">
                <mat-header-cell *matHeaderCellDef class="centered" mat-sort-header>Grade</mat-header-cell>
                <mat-cell *matCellDef="let student" class="centered">{{student.GradeLevel}}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="Actions">
                <mat-header-cell *matHeaderCellDef class="centered">Action(s)</mat-header-cell>
                <mat-cell *matCellDef="let student" class="centered">
                    <button mat-raised-button color="primary" (click)="ViewStudent(student)">Select</button>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="SmallDisplay">
                <mat-header-cell *matHeaderCellDef class="centered">Student(s)</mat-header-cell>
                <mat-cell *matCellDef="let student">
                    <div fxLayout="column" fxLayoutAlign="start stretch">
                        <div fxLayout="row" fxLayoutAlign="space-between center">
                            <div>Student ID</div>
                            <div>
                                <mat-icon *ngIf="student.UpcomingSchoolYear">info</mat-icon>
                            <span>{{student.StudentID}}</span>
                            </div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="space-between center">
                            <div>Last Name</div>
                            <div>{{student.LastName | titleCase}}</div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="space-between center">
                            <div>First Name</div>
                            <div>{{student.FirstName | titleCase}}</div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="space-between center">
                            <div>Middle Name</div>
                            <div>{{student.MiddleName | titleCase}}</div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="space-between center">
                            <div>School</div>
                            <div style="text-align: right">{{student.SchoolName}}</div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="space-between center">
                            <div>Grade</div>
                            <div>{{student.GradeLevel}}</div>
                        </div>
                        <div class="smalldisplaybuttongroup" fxLayout="column" fxLayoutAlign="start center">
                            <button mat-raised-button color="primary" (click)="ViewStudent(student)">Select</button>
                        </div>
                    </div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="NoData">
                <mat-header-cell *matHeaderCellDef>&nbsp;</mat-header-cell>
                <mat-cell *matCellDef="let student">No search results were found with the provided search criteria.</mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="VisibleHeaders"></mat-header-row>
            <mat-row *matRowDef="let row;columns: VisibleColumns; let $even = even" [class.primarybackground50]="$even"></mat-row>
        </mat-table>
        <mat-paginator #paginator [length]="SearchData?.data.length" [pageIndex]="0" [pageSize]="(SmallDisplay ? 5 : 10)" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
    </div>

</div>


// WEBPACK FOOTER //
// ./src/app/studentsearch/studentsearch.component.html